export const LOAD_CONTENT = 'hg/confirmation/LOAD_CONTENT';
export const DL_PAGE_LOADED = 'hg/confirmation/DL_PAGE_LOADED';
export const SET_DATA_QUICKCHECKOUT = 'hg/confirmation/SET_DATA_QUICKCHECKOUT';

export const loadContent = () => {
  return {
    type: LOAD_CONTENT
  };
};



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/QuickCheckout/confirmation/confirmation.js
 **/